/**
 * NmbIconButton — an icon-only button in the menu builder with the Hebrew
 * tooltip every such button must carry: on hover, on keyboard focus, and on
 * long-press where hover does not exist (HoverTip). `label` doubles as the
 * aria-label so screen readers get the same words.
 */

import HoverTip from "../../ui/HoverTip";

const NmbIconButton = ({ label, variant = "", className = "", children, ...rest }) => (
  <HoverTip text={label}>
    <button
      type="button"
      className={`nmb-icon-btn ${variant} ${className}`.trim()}
      aria-label={label}
      {...rest}
    >
      {children}
    </button>
  </HoverTip>
);

export default NmbIconButton;
